module.exports = __webpack_public_path__ + "img/7.6c8f9f63.svg";